import {svgIconWrapper} from '../svg-icon-wrapper';

import BracketsRegular from './brackets-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BracketsRegular {...validProps} />;
}

SvgComponent.iconName = 'brackets-regular';

export const BracketsRegularIcon = svgIconWrapper(SvgComponent);
